export default __webpack_public_path__ + "static/media/ic_telegram.15607035.svg";